import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { parseUri } from '../util';

const PROVIDER = 'https://northpassprovider.evipscloud.com';
const LAST_PATH_KEY = 'last path';

interface IContentFrameProps {
  searchValue: string | null;
  finishSearch: () => void;
}
export function ContentFrame({
  searchValue,
  finishSearch,
}: IContentFrameProps) {
  const ref = useRef<any>();

  useEffect(() => {
    if (typeof searchValue === 'string') {
      // push url to search for the string
      // console.log(ref.current.src);
      // console.log(ref.current);
      // console.log(parseUri(ref.current.src));
      const uri = parseUri(ref.current.src);

      let paramString = '';
      const keys = Object.keys(uri.queryKey);
      keys.forEach((key) => {
        if (key === 'q') return;
        paramString += `&${key}=${uri.queryKey[key]}`;
      });
      ref.current.src =
        PROVIDER +
        `/catalog_search?utf8=✓&q=${encodeURIComponent(
          searchValue
        )}${paramString}`;
      finishSearch();
    }
  }, [searchValue]);

  useEffect(() => {
    function onMessage(event: MessageEvent) {
      let pName = event.data;
      const lastPath = localStorage.getItem(LAST_PATH_KEY);

      if (lastPath === pName) return;
      if (typeof pName === 'string') {
      } else {
        pName = '/';
      }
      window.history.pushState({}, '', pName);
      localStorage.setItem(LAST_PATH_KEY, pName);
    }
    function onLocationChange(event: PopStateEvent) {
      const pName = window.location.pathname + window.location.search;

      ref.current.src = PROVIDER + pName;
    }
    window.addEventListener('message', onMessage);
    window.addEventListener('popstate', onLocationChange);
    return () => {
      window.removeEventListener('popstate', onLocationChange);
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return (
    <StyledContentFrame
      ref={ref}
      src={PROVIDER + window.location.pathname + window.location.search}
      frameBorder='0'
      onLoad={(event) => {
        // console.log(event.target);
        // if (event.target) {
        //   const t: any = event.target;
        //   console.log(t.src);
        // }
      }}
      //   sandbox="true"
      allowFullScreen
    ></StyledContentFrame>
  );
}

const StyledContentFrame = styled.iframe`
  width: 100vw;
  height: calc(100vh - 58px);
`;
